// extracted by mini-css-extract-plugin
export default {"quick-info":"_fwmim","quickInfo":"_fwmim"};